import React from 'react';
import { Icon, Modal, message, Row, Col, } from 'antd';
import Event from 'react-eventproxy';
import { SocketAreaView } from '../../../utils/websocket';
import BaseContaier from '../../../containers/base';
import Background from '../../../images/view_bg.png';
import API, { url } from '../../../utils/api';
import Common from '../../../components/common';

export default class areaView extends BaseContaier {
    constructor(props) {
        super(props);
        this.state = {
            areaView: [],
        }
    }

    componentDidMount() {
        this.getInfoList()
    }

    getInfoList = () => {
        const storeId = Common.getStoreInfo().storeId
        const hide = message.loading('请稍后 ...');
        API.queuesView(storeId).then((res) => {
            // console.log(res)
            this.setState({
                areaView: res
            }, this.areaEvent)
            hide();
        }).catch((e) => {
            hide();
            message.error(`查询失败:${e}`);
        })
    }

    areaEvent = () => {
        const self = this;
        Event.on(SocketAreaView, ({ data, option }) => {
            // console.log("区域视图推送", option);
            const { areaView } = self.state;
            if (option == 'areaUpdate' || option == 'customerRemove' || option == 'customerAdd') {
                let areaTypeIndex = -1
                let newAreaView = [...areaView]
                newAreaView.forEach((item, index) => {
                    if (item.areaId == data[0].areaId) {
                        item.areaStatus = data[0].areaStatus
                        areaTypeIndex = index
                    }
                })
                if (areaTypeIndex > -1) {
                    newAreaView[areaTypeIndex] = data[0]
                    self.setState({
                        areaView: newAreaView
                    })
                }
            }
        });
    }

    render() {
        const offSW = document.querySelector('body').offsetWidth - 120;
        const style = { background: '#1A1736', padding: 20, borderRadius: 5,minHeight:120 };
        const { areaView} = this.state
        return (
            <div style={{ backgroundColor: '#252041', padding: '20px 20px', width: offSW, minHeight: 850 }}>
                <div style={{width: offSW-40,columnCount:4}}>
                    {
                        areaView && areaView.length > 0 ? (areaView.map((item, index) => {
                            return (
                                <div style={{ fontSize: 14, color: '#6E738E',breakInside:'avoid',marginTop:index == 0?0:15}} key={`area-${item.areaId}`}>
                                    <div style={style} key={`lkju-${index}`}>
                                        <div style={{ backgroundColor: '#322F52', borderRadius: 15, padding: '5px 10px',color: 'white',display:'inline',}} key={`uehu-${index}`}>
                                                <span style={{display:'inline-block', width: 14, height: 14, backgroundColor: item.areaStatus ? '#E25050' : '#82FF60', borderRadius: '50%', marginRight: 5,}}></span>
                                            {item.areaName}
                                        </div>
                                        {
                                            item.queueCustomerNum && item.queueCustomerNum.length > 0 ? <div style={{ marginTop: 20, }} >
                                                <Row>
                                                    {
                                                        item.queueCustomerNum.map((it, index) => {
                                                            return (
                                                                <Col span={4} key={`oiu-${index}`}>
                                                                    <div style={{ width: 46, height: 46, background: `url(${Background})`, backgroundSize: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 12, color: 'white', marginBottom: 10 }} key={`asd-${index}`}>
                                                                        {it}
                                                                    </div>
                                                                </Col>
                                                            )
                                                        })
                                                    }
                                                </Row>
                                            </div> : <div style={{ marginTop: 20, justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' ,}}>
                                                    <img src={require('../../../images/bitmap_icon.png')} style={{ width: 60, height: 48 }} />
                                                    <div style={{ fontSize: 14, color: 'white', marginTop: 10 }}>暂无数据…</div>
                                                </div>
                                        }
                                    </div>
                                </div>
                            )
                        })) : null
                    }
                </div>
                
            </div>
        );
    }
    
}